import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Panel, PanelGroup } from 'react-bootstrap';
import Fa from 'react-fontawesome';

import SearchPath from '../../../../components/search-path';
import SearchField from '../../../../components/search-field';

const SEPARATOR = ':';

class TokenPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: null,
      universalSearchPath: '',
    };
    this.addToken = this.addToken.bind(this);
    this.updateCustomFieldSearchPath = this.updateCustomFieldSearchPath.bind(this);
    this.shouldRenderItem = this.shouldRenderItem.bind(this);
  }

  addToken(token) {
    this.props.addToken(token);
  }

  shouldRenderItem(item) {
    const { restrict, source } = this.props;
    return !((restrict && item.restrict) || (item.sources && !item.sources?.includes(source)));
  }

  updateCustomFieldSearchPath(paths, fieldInfo) {
    const token = {
      sources: paths,
      value: `{${paths.join(SEPARATOR)}}`,
      label: fieldInfo ? fieldInfo.name : 'Custom field',
    };
    this.props.addToken(token);
  }

  renderPanel(token, rows) {
    const { selectedTab } = this.state;
    const isActive = token.value === selectedTab;
    return (
      <Panel
        eventKey={token.value}
        key={token.value}
      >
        <Panel.Heading>
          <Panel.Title>
            <Panel.Toggle componentClass="div">
              <table style={{ cursor: 'pointer'}}>
                <tbody>
                  <tr>
                    <td width="99%">{token.label}</td>
                    <td style={{ paddingLeft: 10, paddingRight: 3 }}><Fa name={isActive ? 'caret-up' : 'caret-down'} /></td>
                  </tr>
                </tbody>
              </table>
            </Panel.Toggle>
          </Panel.Title>
        </Panel.Heading>
        <Panel.Body collapsible style={{ padding: 0 }}>
          <div>
            <table style={{ margin: 0 }} className="table table-condensed table-hover table-striped">
              <tbody>
                {rows}
              </tbody>
            </table>
          </div>
        </Panel.Body>
      </Panel>
    );
  }

  renderCustomFieldPanel() {
    const { source } = this.props;
    const isAccount = source === 'account';

    const token = {
      value: 'custom-fields',
      label: 'Custom Fields',
    };

    const inner = (
      <SearchPath
        paths={[]}
        onUpdate={this.updateCustomFieldSearchPath}
        selectedSearchPaths={[]}
        startingNode={isAccount ? 'Account' : 'Opportunity'}
      />
    );

    return this.renderPanel(token, inner);
  }

  renderUniversalSearchPath() {
    const { tokens } = this.props;
    const { universalSearchPath } = this.state;

    const rows = [];
    if (universalSearchPath && universalSearchPath !== '') {
      const values = tokens.filter(this.shouldRenderItem)
        .reduce((items, token) => {
          token.values.filter(this.shouldRenderItem)
            .forEach((val) => {
              if (val.value.toLowerCase().includes(universalSearchPath.toLowerCase())) {
                items.push(val);
              }
            });
          return items;
        }, []);

      if (values.length > 0) {
        rows.push(...values.map((val) => (
          <tr key={val.value} title={val.label} onClick={(e) => { e.stopPropagation(); this.addToken(val); }}>
            <td style={{ cursor: 'pointer' }}>
              <code>{val.value}</code>
            </td>
          </tr>
        )));
      } else {
        rows.push(<tr><td><i style={{ margin: 5 }}>No email tokens found.</i></td></tr>);
      }
    }

    return (
      <Panel>
        <PanelGroup id="universal-search-panel">
          <Panel.Heading>
            <Panel.Title>
              <table>
                <tbody>
                  <tr>
                    <td>
                      <SearchField
                        disabled={false}
                        onSearch={(query) => this.setState({ universalSearchPath: query })}
                        collapsible
                        autoFocus
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </Panel.Title>
          </Panel.Heading>
          <Panel.Body style={{ padding: 0, maxHeight: '300px', overflowX: 'hidden', overflowY: 'auto' }}>
            <table style={{ margin: 0 }} className="table table-condensed table-hover table-striped">
              <tbody>
                {rows}
              </tbody>
            </table>
          </Panel.Body>
        </PanelGroup>
      </Panel>
    );
  }

  render() {
    const { selectedTab } = this.state;
    const { tokens, showCustomFields } = this.props;
    return (
      <div>
        {this.renderUniversalSearchPath()}
        <PanelGroup
          accordion
          id="token-panel"
          activeKey={selectedTab}
          onSelect={(tab) => { this.setState({ selectedTab: tab }) }}
          style={{ marginBottom: 0 }}
        >
          {tokens.filter(this.shouldRenderItem)
            .map((token) => {
              const rows = token.values.filter(this.shouldRenderItem)
                .reduce((items, val) => {
                  items.push((
                    <tr key={val.value} title={val.label} onClick={(e) => { e.stopPropagation(); this.addToken(val); }}>
                      <td style={{ cursor: 'pointer' }}>
                        <code>{val.value}</code>
                      </td>
                    </tr>
                  ));
                  return items;
                }, []);
              return (rows.length > 0) ? this.renderPanel(token, rows) : null;
            })}
          {showCustomFields && this.renderCustomFieldPanel()}
        </PanelGroup>
      </div>
    );
  }
}

TokenPanel.propTypes = {
  addToken: PropTypes.func,
  restrict: PropTypes.bool,
  tokens: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
    type: PropTypes.string,
    restrict: PropTypes.bool,
    values: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
      type: PropTypes.string,
      restrict: PropTypes.bool,
    })),
  })).isRequired,
  source: PropTypes.string,
  showCustomFields: PropTypes.bool,
};

TokenPanel.defaultProps = {
  addToken: () => {},
  restrict: false,
  source: 'opportunity',
  showCustomFields: false,
};

TokenPanel.SEPARATOR = SEPARATOR;

export default TokenPanel;
